import React, { useState } from 'react'

import { Flex, SelectInput, Td, Tr } from '@components'
import Breadcrumb from '@components/Breadcrumb'
import { DashboardTable } from '@components/DashboardTable'
import PageTitle from '@components/PageTitle'
import Template from '@components/Template'
import { TopAccessedContent } from '@models/mostAccessed.model'
import { useGetTopAccessedQuery } from '@services/MostAccessedApi'
import { ArrowDown, ArrowUp, Minus } from 'lucide-react'
import '../../styles/index.css'

export default function MostAccessed() {
	const currentDate = new Date()
	const previousMonth = currentDate.getMonth() + 1
	const actualYear = currentDate.getFullYear()

	const [yearFilter, setYearFilter] = useState<string | number>(actualYear)
	const [monthFilter, setMonthFilter] = useState<string | number>(previousMonth)

	const { data, isLoading, isFetching } = useGetTopAccessedQuery({
		year: yearFilter,
		month: monthFilter,
	})

	const monthOptions = [
		{ option: 'Selecione um mês', value: '' },
		{ option: 'Janeiro', value: '1' },
		{ option: 'Fevereiro', value: '2' },
		{ option: 'Março', value: '3' },
		{ option: 'Abril', value: '4' },
		{ option: 'Maio', value: '5' },
		{ option: 'Junho', value: '6' },
		{ option: 'Julho', value: '7' },
		{ option: 'Agosto', value: '8' },
		{ option: 'Setembro', value: '9' },
		{ option: 'Outubro', value: '10' },
		{ option: 'Novembro', value: '11' },
		{ option: 'Dezembro', value: '12' },
	]

	const yearOptions = [
		{ option: 'Selecione um ano', value: '' },
		{ option: '2026', value: '2026' },
	]

	return (
		<div>
			<Template>
				<Breadcrumb />
				<PageTitle title='Mais Acessados' />

				<div className='grid grid-cols-2 gap-x-8 mt-8 mb-8'>
					<DashboardTable
						title='Materiais mais acessados'
						columns={[
							{ label: 'Material' },
							{ label: 'Quantidade de Acessos' },
						]}
						data={data?.contents || []}
						isLoading={isLoading || isFetching}
						filters={
							<>
								<div className='w-full'>
									<SelectInput
										btnClass='w-full py-[8px] px-[13px] border border-gray-300 rounded flex justify-between items-center'
										options={yearOptions}
										selectedValue={yearFilter}
										onChange={(e) => setYearFilter(e.value)}
									/>
								</div>
								<div className='w-full'>
									<SelectInput
										btnClass='w-full py-[8px] px-[13px] border border-gray-300 rounded flex justify-between items-center'
										options={monthOptions}
										selectedValue={monthFilter}
										onChange={(e) => setMonthFilter(e.value)}
									/>
								</div>
							</>
						}
						renderRow={(item: TopAccessedContent) => {
							const percent = item.viewsChangePercent
							const hasChange = percent !== null && percent !== undefined

							let colorClass = 'text-gray-400'
							let Icon = Minus

							if (hasChange && percent > 0) {
								colorClass = 'text-green-500'
								Icon = ArrowUp
							} else if (hasChange && percent < 0) {
								colorClass = 'text-red-500'
								Icon = ArrowDown
							}

							return (
								<Tr key={item.contentId}>
									<Td className='px-[12px] py-[10px] w-[70%]'>
										<Flex className='items-center gap-4 font-medium text-gray-800'>
											{item.contentName}
										</Flex>
									</Td>
									<Td className='w-[30%] text-end pr-[18px]'>
										<div className='flex flex-col items-end justify-center'>
											<span className='font-bold text-primary-light'>
												{item.accessCount}
											</span>

											{hasChange && (
												<span
													className={`text-xs font-medium flex items-center gap-1 mt-1 ${colorClass}`}
												>
													<Icon size={14} strokeWidth={2.5} />
													{percent !== 0 && `${Math.abs(percent)}%`}
												</span>
											)}
										</div>
									</Td>
								</Tr>
							)
						}}
					/>
				</div>
			</Template>
		</div>
	)
}
